import {
    Avatar,
    Card,
    Checkbox,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel,
    Grid,
    Typography,
} from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import image1 from '../Images/ICICI.png'
import image2 from '../Images/HDFC.png'
import image3 from '../Images/NB.jpg'
import image4 from '../Images/UPI.jpg'
import image5 from '../Images/VTap.jfif'
import image6 from '../Images/Axis.png'
import image7 from '../Images/Kotak.jpg'
import image8 from '../Images/Jio.png'

import pinelabPNG from '../Images/pinelab.png'
import {
    CLEAR_STATE,
    getPaymentRequestData,
    getCreditCustomerLimitDetail,
    createPaymentRequestData,
    processCancelledTransaction,
    getSavedCardDetailByClientID,
    SAVE_CARD_DATA,
} from '../../redux/actions/ComponentCallsActions'
import { useDispatch, useSelector } from 'react-redux'
import CryptoJS from 'crypto-js'
import { EncKeys } from '../../../config'
import LockIcon from '@material-ui/icons/Lock'
import UPI from './UPI'
import { useHistory, useParams } from 'react-router-dom'
import { DateUtilService } from '../../services/date-util-service'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import HdfcPage from './HdfcPage'
import NetBanking from './NetBanking'
import VTap from './VTap'
import { VTapPayment } from '../../redux/actions/ComponentCallsActions'
import $ from 'jquery'
import { alertService } from '../../services/alert-service'
import initialState from '../../redux/reducers/ComponentCallsReducer'
import AxisPage from './AxisPage'
import KotakPage from './KotakPage'
import JioPayCard from './JioPayCard'
import JioPayUPI from './JioPayUPI'
import JioPayNetBanking from './JioPayNetBanking'
import JioPayDebitCard from './JioPayDebitCard'

const Checkout = () => {
    const [open, setOpen] = React.useState(false)
    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }
    const [expanded, setExpanded] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()
    const { token } = useParams()
    const loading = useSelector((state) => state.pageLoadingState)
    const [charges, setCharges] = useState()
    const [acceptCharges, setAcceptCharges] = useState(false)
    const [paymentData, setPaymentData] = useState({
        customerData: {
            UIConfig: {
                LogoURI: 'https://www.vendortopay.com/images/defaultlogo.png',
                LogoPosition: 'Center',
                BackgroundColor: '#bf4bcc',
                ButtonBackgroundColor: '#4b6bcc',
                ButtonTextColor: '#ffffff',
                BackgroundImage:
                    'https://www.vendortopay.com/images/DefaultGateway2.png',
                ShowBackgroundImage: true,
            },
            PaymentRequest: {
                TrackID: '',
                OrderNo: '',
                Remarks: '',
                Amount: '',
                RedirectUrl: '',
            },
            PaymentOptions: {
                HDFCSeamless: false,
                HDFCOff: false,
                ICICIOn: false,
                ICICIOff: false,
                NetB: false,
                VTAP: false,
                PineLab: false,
                Axis: false,
                Kotak: false,
                HDFCNetBanking: false,
                JioPay: false,
                HDFCSmart: false,
            },
        },
    })
    const [bankName, setBankName] = React.useState('')
    const [paymentRequest, setPaymentRequest] = useState({
        RedirectUrl: '',
        AccessCode: '',
        StrEncRequest: '',
    })
    const [paymentGatewayOption, setPaymentGatewayOption] = useState({
        isHDFCVisible: false,
        isVTAPVisible: false,
        showVtapOTP: false,
        isUPIVisible: false,
        isNetBankingVisible: false,
        isPineLabVisible: false,
        isPaymentOptionVisible: true,
        isAxisVisible: false,
        isKotakVisible: false,
        isHDFCNetBankingVisible: false,
        isJioPayCardVisible: false,
        isJioPayUPIVisible: false,
        isJioPayNetBankingVisible: false,
        isJioPayDebitCardVisible: false,
        isHDFCSmartVisible: false,
    })
    const [creditLimit, setCreditLimit] = useState({
        Limit: 0,
        CreditAccountNo: '',
        Passcode: '',
        Phone: '',
        Email: '',
        CustomerId: 0,
    })

    const [transactionResponse, setTransactionResponse] = useState({
        Comments: 'Please Contact Vayana Team for further details',
        Status: 'Transaction declined',
        TransactionId: '',
        TrackId: '',
        Amount: '',
        TransactionDate: '',
        RedirectUrl: '',
    })
    const key = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey)
    const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV)

    useEffect(() => {
        dispatch({
            type: CLEAR_STATE,
        })

        // var duration = 60
        // setInterval(updateTimer, 1000)
        // function updateTimer() {
        //     duration--
        //     if (duration < 1) {
        //         handleClickOpen()
        //         setTimeout(() => {
        //             window.location = '/PaymentFailed'
        //         }, 5000)
        //     } else {
        //         console.log(duration)
        //     }
        //     window.addEventListener('mousemove', resetTimer)
        //     function resetTimer() {
        //         duration = 60
        //     }
        // }

        const PaymentRequest = () => {
            const key = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey)
            const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV)

            let encryptedToken = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(token.toString()),
                key,
                {
                    keySize: 128 / 8,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7,
                }
            )

            let data = {
                payload: encryptedToken.toString(),
            }

            dispatch(
                getPaymentRequestData(
                    data,
                    (res) => {
                        if (res.statusCode !== 200) {
                            handleError(res.errorMessage)
                        } else {
                            const decryptedResponse = CryptoJS.AES.decrypt(
                                res.data,
                                key,
                                {
                                    keySize: 128 / 8,
                                    iv: iv,
                                    mode: CryptoJS.mode.CBC,
                                    padding: CryptoJS.pad.Pkcs7,
                                }
                            )
                            const decrypted = decryptedResponse.toString(
                                CryptoJS.enc.Utf8
                            )
                            let actualResponse = JSON.parse(decrypted)
                            // console.log(actualResponse)
                            let temp = { ...paymentData }
                            temp.customerData = { ...actualResponse }
                            // console.log(temp)
                            setPaymentData(temp)
                        }
                    },
                    (err) => {
                        handleError('')
                    }
                )
            )
        }
        PaymentRequest()
    }, [])

    const handlePGOptionsVisibility = (option) => {
        let temp = { ...paymentGatewayOption }
        temp.isHDFCVisible = false
        temp.isNetBankingVisible = false
        temp.isUPIVisible = false
        temp.isVTAPVisible = false
        temp.isPaymentOptionVisible = false
        temp.showVtapOTP = false
        temp.isPineLabVisible = false
        temp.isAxisVisible = false
        temp.isKotakVisible = false
        temp.isHDFCNetBankingVisible = false
        temp.isJioPayCardVisible = false
        temp.isJioPayUPIVisible = false
        temp.isJioPayNetBankingVisible = false
        temp.isJioPayDebitCardVisible = false
        temp.isHDFCSmartVisible = false

        if (option === 'hdfc') {
            temp.isHDFCVisible = true
        } else if (option === 'kotak') {
            temp.isKotakVisible = true
        } else if (option === 'upi') {
            temp.isUPIVisible = true
        } else if (option === 'netBanking') {
            temp.isNetBankingVisible = true
        } else if (option === 'vtap') {
            getVTAPCreditLimit()
            temp.isVTAPVisible = true
        } else if (option === 'pineLab') {
            temp.isPineLabVisible = true
        } else if (option === 'axis') {
            temp.isAxisVisible = true
        } else if (option === 'hdfc-netbanking') {
            temp.isHDFCNetBankingVisible = true
        } else if (option === 'jioPayCard') {
            temp.isJioPayCardVisible = true
        } else if (option === 'jioPayUpi') {
            temp.isJioPayUPIVisible = true
        } else if (option === 'jioPayNetBanking') {
            temp.isJioPayNetBankingVisible = true
        } else if (option === 'jioPayDebitCard') {
            temp.isJioPayDebitCardVisible = true
        } else if (option === 'hdfcsmart') {
            temp.isHDFCSmartVisible = true
        }
        setPaymentGatewayOption(temp)
    }

    const handleBackBtn = () => {
        let temp = { ...paymentGatewayOption }
        temp.isHDFCVisible = false
        temp.isNetBankingVisible = false
        temp.isUPIVisible = false
        temp.isVTAPVisible = false
        temp.showVtapOTP = false
        temp.isAxisVisible = false
        temp.isKotakVisible = false
        temp.isHDFCNetBankingVisible = false
        temp.isPaymentOptionVisible = true
        temp.isJioPayCardVisible = false
        temp.isJioPayUPIVisible = false
        temp.isJioPayNetBankingVisible = false
        temp.isJioPayDebitCardVisible = false
        temp.isHDFCSmartVisible = false

        setPaymentGatewayOption(temp)
        setCharges()
    }

    const handleBankList = (event) => {
        const {
            target: { value },
        } = event
        setBankName(value)
    }

    const getVTAPCreditLimit = () => {
        const uid = paymentData.customerData.PaymentRequest.Uid
        const key = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey)
        const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV)

        let encryptedToken = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(uid.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        let data = {
            payload: encryptedToken.toString(),
        }

        dispatch(
            getCreditCustomerLimitDetail(
                data,
                (res) => {
                    if (res.statusCode === 200) {
                        const decryptedResponse = CryptoJS.AES.decrypt(
                            res.data,
                            key,
                            {
                                keySize: 128 / 8,
                                iv: iv,
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7,
                            }
                        )
                        const decrypted = decryptedResponse.toString(
                            CryptoJS.enc.Utf8
                        )
                        let actualResponse = JSON.parse(decrypted)
                        let temp = { ...creditLimit }
                        temp.Limit = actualResponse.Limit
                        temp.CreditAccountNo = actualResponse.CreditAccountNo
                        temp.Passcode = actualResponse.Passcode
                        temp.Phone = actualResponse.Phone
                        temp.Email = actualResponse.Email
                        temp.CustomerId = actualResponse.CustomerId
                        setCreditLimit(temp)
                    } else {
                        handleError(res.errorMessage)
                    }
                },
                (err) => {
                    handleError('')
                }
            )
        )
    }

    const submitVtapPayment = (encryptedData) => {
        const key = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey)
        const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV)
        let data = {
            payload: encryptedData.toString(),
        }
        const Decryptedbody = CryptoJS.AES.decrypt(encryptedData, key, {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        })
        const decrypted = Decryptedbody.toString(CryptoJS.enc.Utf8)
        let Response = JSON.parse(decrypted)
        dispatch(
            VTapPayment(
                data,
                (res) => {
                    if (res.statusCode === 200) {
                        const decryptedResponse = CryptoJS.AES.decrypt(
                            res.data,
                            key,
                            {
                                keySize: 128 / 8,
                                iv: iv,
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7,
                            }
                        )
                        const decrypted = decryptedResponse.toString(
                            CryptoJS.enc.Utf8
                        )
                        let actualResponse = JSON.parse(decrypted)
                        if (actualResponse.Message === 'OTP Required') {
                            let temp = { ...paymentGatewayOption }
                            temp.showVtapOTP = true
                            setPaymentGatewayOption(temp)
                        } else if (
                            actualResponse.Status !== '' &&
                            actualResponse.Status != null
                        ) {
                            history.push({
                                pathname: '/TransactionStatus',
                                state: actualResponse,
                            })
                        } else {
                            handleError(actualResponse.Message)
                        }
                    } else {
                        handleError(res.errorMessage)
                    }
                },
                (err) => {
                    handleError('')
                }
            )
        )
    }

    const handleError = (errorMessage) => {
        let temp = { ...transactionResponse }
        temp.Comments = errorMessage !== '' ? errorMessage : temp.Comments
        temp.RedirectUrl =
            paymentData.customerData.PaymentRequest.RedirectUrl === undefined
                ? ''
                : paymentData.customerData.PaymentRequest.RedirectUrl
        setTransactionResponse(temp)
        history.push({
            pathname: '/TransactionStatus',
            state: temp,
        })
    }

    //payment button click funtionality of netbanking
    const SubmitRequest = () => {
        if (bankName === '' || bankName === undefined || bankName === null) {
            alertService.addError('Please select bank to process payment ')
            return false
        }

        const postRequest = {
            CustomerPaymentReqID: paymentData.customerData.PaymentRequest.Id,
            AgentID: paymentData.customerData.PaymentRequest.ClientId,
            PaymentOption: 'NetBanking',
            TrackId: paymentData.customerData.PaymentRequest.TrackID,
            TotalAmount: paymentData.customerData.PaymentRequest.Amount,
            BankName: bankName,
            Cvv: '',
            ExpiryMonth: '',
            ExpiryYear: '',
            CardHolderName: '',
            CardNo: '',
            UDF1: paymentData.customerData.PaymentRequest.UDF1,
            UDF2: paymentData.customerData.PaymentRequest.UDF2,
            UDF3: paymentData.customerData.PaymentRequest.UDF3,
            UDF4: paymentData.customerData.PaymentRequest.UDF4,
            UDF5: paymentData.customerData.PaymentRequest.UDF5,
        }
        const jsonBody = JSON.stringify(postRequest)

        let encryptedPostRequest = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        let postData = {
            payload: encryptedPostRequest.toString(),
        }

        dispatch(
            createPaymentRequestData(
                postData,
                (res) => {
                    if (res.statusCode === 200) {
                        const decryptedResponse = CryptoJS.AES.decrypt(
                            res.data,
                            key,
                            {
                                keySize: 128 / 8,
                                iv: iv,
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7,
                            }
                        )
                        const decrypted = decryptedResponse.toString(
                            CryptoJS.enc.Utf8
                        )
                        localStorage.setItem('gateway', 'NetBanking')

                        let actualResponse = JSON.parse(decrypted)
                        let requestResponse = JSON.parse(actualResponse)
                        let paymentRequestResponse = { ...requestResponse }

                        // console.log(paymentRequestResponse)
                        setPaymentRequest(paymentRequestResponse)
                        setInterval(() => {
                            $('#nonseamless').submit()
                        }, 1000)
                    } else {
                        const transactionResponse = {
                            Comments: res.errorMessage,
                            Status: 'Transaction declined',
                            TransactionId: '',
                            TrackId: '',
                            Amount: '',
                            TransactionDate: '',
                            RedirectUrl:
                                paymentData.customerData.PaymentRequest
                                    .RedirectUrl,
                        }
                        history.push({
                            pathname: '/TransactionStatus',
                            state: transactionResponse,
                        })
                    }
                },
                (err) => {
                    const transactionResponse = {
                        Comments:
                            'Please Contact Vayana Team for further details',
                        Status: 'Transaction declined',
                        TransactionId: '',
                        TrackId: '',
                        Amount: '',
                        TransactionDate: '',
                        RedirectUrl:
                            paymentData.customerData.PaymentRequest.RedirectUrl,
                    }
                    history.push({
                        pathname: '/TransactionStatus',
                        state: transactionResponse,
                    })
                }
            )
        )
    }
    //payment button click funtionality of HDFC netbanking
    const SubmitRequestHDFCNetBanking = () => {
        const postRequest = {
            CustomerPaymentReqID: paymentData.customerData.PaymentRequest.Id,
            AgentID: paymentData.customerData.PaymentRequest.ClientId,
            PaymentOption: 'HDFCNetBanking',
            TrackId: paymentData.customerData.PaymentRequest.TrackID,
            TotalAmount: paymentData.customerData.PaymentRequest.Amount,
            BankName: '',
            Cvv: '',
            ExpiryMonth: '',
            ExpiryYear: '',
            CardHolderName: '',
            CardNo: '',
            UDF1: paymentData.customerData.PaymentRequest.UDF1,
            UDF2: paymentData.customerData.PaymentRequest.UDF2,
            UDF3: paymentData.customerData.PaymentRequest.UDF3,
            UDF4: paymentData.customerData.PaymentRequest.UDF4,
            UDF5: paymentData.customerData.PaymentRequest.UDF5,
        }
        const jsonBody = JSON.stringify(postRequest)

        let encryptedPostRequest = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        let postData = {
            payload: encryptedPostRequest.toString(),
        }
        dispatch(
            createPaymentRequestData(
                postData,
                (res) => {
                    // console.log("res",res)
                    if (res.statusCode === 200) {
                        const decryptedResponse = CryptoJS.AES.decrypt(
                            res.data,
                            key,
                            {
                                keySize: 128 / 8,
                                iv: iv,
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7,
                            }
                        )
                        const decrypted = decryptedResponse.toString(
                            CryptoJS.enc.Utf8
                        )
                        // console.log("paymentResp",decrypted)
                        localStorage.setItem('gateway', 'HDFCNetBanking')

                        let actualResponse = JSON.parse(decrypted)
                        window.location.href = actualResponse
                    } else {
                        const transactionResponse = {
                            Comments: res.errorMessage,
                            Status: 'Transaction declined',
                            TransactionId: '',
                            TrackId: '',
                            Amount: '',
                            TransactionDate: '',
                            RedirectUrl:
                                paymentData.customerData.PaymentRequest
                                    .RedirectUrl,
                        }
                        history.push({
                            pathname: '/TransactionStatus',
                            state: transactionResponse,
                        })
                    }
                },
                (err) => {
                    console.error('❌ Error in createPaymentRequestData:', err)
                    const transactionResponse = {
                        Comments:
                            'Please Contact Vayana Team for further details',
                        Status: 'Transaction declined',
                        TransactionId: '',
                        TrackId: '',
                        Amount: '',
                        TransactionDate: '',
                        RedirectUrl:
                            paymentData.customerData.PaymentRequest.RedirectUrl,
                    }
                    history.push({
                        pathname: '/TransactionStatus',
                        state: transactionResponse,
                    })
                }
            )
        )
    }

    const SubmitPineLabRequest = () => {
        const postRequest = {
            CustomerPaymentReqID: paymentData.customerData.PaymentRequest.Id,
            AgentID: paymentData.customerData.PaymentRequest.ClientId,
            PaymentOption: 'PineLab',
            TrackId: paymentData.customerData.PaymentRequest.TrackID,
            TotalAmount: paymentData.customerData.PaymentRequest.Amount,
            BankName: '',
            Cvv: '',
            ExpiryMonth: '',
            ExpiryYear: '',
            CardHolderName: '',
            CardNo: '',
            UDF1: paymentData.customerData.PaymentRequest.UDF1,
            UDF2: paymentData.customerData.PaymentRequest.UDF2,
            UDF3: paymentData.customerData.PaymentRequest.UDF3,
            UDF4: paymentData.customerData.PaymentRequest.UDF4,
            UDF5: paymentData.customerData.PaymentRequest.UDF5,
        }
        const jsonBody = JSON.stringify(postRequest)

        let encryptedPostRequest = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        let postData = {
            payload: encryptedPostRequest.toString(),
        }

        dispatch(
            createPaymentRequestData(
                postData,
                (res) => {
                    if (res.statusCode === 200) {
                        const decryptedResponse = CryptoJS.AES.decrypt(
                            res.data,
                            key,
                            {
                                keySize: 128 / 8,
                                iv: iv,
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7,
                            }
                        )
                        const decrypted = decryptedResponse.toString(
                            CryptoJS.enc.Utf8
                        )
                        localStorage.setItem('gateway', 'PineLab')

                        let actualResponse = JSON.parse(decrypted)

                        window.location.replace(actualResponse)
                    } else {
                        const transactionResponse = {
                            Comments: res.errorMessage,
                            Status: 'Transaction declined',
                            TransactionId: '',
                            TrackId: '',
                            Amount: '',
                            TransactionDate: '',
                            RedirectUrl:
                                paymentData.customerData.PaymentRequest
                                    .RedirectUrl,
                        }
                        history.push({
                            pathname: '/TransactionStatus',
                            state: transactionResponse,
                        })
                    }
                },
                (err) => {
                    const transactionResponse = {
                        Comments:
                            'Please Contact Vayana Team for further details',
                        Status: 'Transaction declined',
                        TransactionId: '',
                        TrackId: '',
                        Amount: '',
                        TransactionDate: '',
                        RedirectUrl:
                            paymentData.customerData.PaymentRequest.RedirectUrl,
                    }
                    history.push({
                        pathname: '/TransactionStatus',
                        state: transactionResponse,
                    })
                }
            )
        )
    }

    //SubmitHDFCSmartRequest
    const SubmitHDFCSmartRequest = () => {
        const postRequest = {
            CustomerPaymentReqID: paymentData.customerData.PaymentRequest.Id,
            AgentID: paymentData.customerData.PaymentRequest.ClientId,
            PaymentOption: 'HDFCSmart',
            TrackId: paymentData.customerData.PaymentRequest.TrackID,
            TotalAmount: paymentData.customerData.PaymentRequest.Amount,
            BankName: '',
            Cvv: '',
            ExpiryMonth: '',
            ExpiryYear: '',
            CardHolderName: '',
            CardNo: '',
            UDF1: paymentData.customerData.PaymentRequest.UDF1,
            UDF2: paymentData.customerData.PaymentRequest.UDF2,
            UDF3: paymentData.customerData.PaymentRequest.UDF3,
            UDF4: paymentData.customerData.PaymentRequest.UDF4,
            UDF5: paymentData.customerData.PaymentRequest.UDF5,
        }
        const jsonBody = JSON.stringify(postRequest)

        let encryptedPostRequest = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        let postData = {
            payload: encryptedPostRequest.toString(),
        }

        dispatch(
            createPaymentRequestData(
                postData,
                (res) => {
                    if (res.statusCode === 200) {
                        const decryptedResponse = CryptoJS.AES.decrypt(
                            res.data,
                            key,
                            {
                                keySize: 128 / 8,
                                iv: iv,
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7,
                            }
                        )
                        const decrypted = decryptedResponse.toString(
                            CryptoJS.enc.Utf8
                        )
                        localStorage.setItem('gateway', 'HDFCSmart')

                        let actualResponse = JSON.parse(decrypted)

                        window.location.replace(actualResponse)
                    } else {
                        const transactionResponse = {
                            Comments: res.errorMessage,
                            Status: 'Transaction declined',
                            TransactionId: '',
                            TrackId: '',
                            Amount: '',
                            TransactionDate: '',
                            RedirectUrl:
                                paymentData.customerData.PaymentRequest
                                    .RedirectUrl,
                        }
                        history.push({
                            pathname: '/TransactionStatus',
                            state: transactionResponse,
                        })
                    }
                },
                (err) => {
                    const transactionResponse = {
                        Comments:
                            'Please Contact Vayana Team for further details',
                        Status: 'Transaction declined',
                        TransactionId: '',
                        TrackId: '',
                        Amount: '',
                        TransactionDate: '',
                        RedirectUrl:
                            paymentData.customerData.PaymentRequest.RedirectUrl,
                    }
                    history.push({
                        pathname: '/TransactionStatus',
                        state: transactionResponse,
                    })
                }
            )
        )
    }

    const CancelTransaction = (e) => {
        if (window && window.parent) {
            window.parent.postMessage({ message: 'ButtonClicked' }, '*')
        }
        // Iframe Code ends here

        const firstTrueParam = Object.entries(
            paymentData.customerData.PaymentOptions
        ).find(([key, value]) => value === true)
        const firstTrueParamName = firstTrueParam ? firstTrueParam[0] : ''

        const postRequest = {
            CustomerPaymentReqID: paymentData.customerData.PaymentRequest.Id,
            AgentID: paymentData.customerData.PaymentRequest.ClientId,
            PaymentOption: firstTrueParamName,
            TrackId: paymentData.customerData.PaymentRequest.TrackID,
            TotalAmount: paymentData.customerData.PaymentRequest.Amount,
            BankName: '',
            Cvv: '',
            ExpiryMonth: '',
            ExpiryYear: '',
            CardHolderName: '',
            CardNo: '',
            UDF1: paymentData.customerData.PaymentRequest.UDF1,
            UDF2: paymentData.customerData.PaymentRequest.UDF2,
            UDF3: paymentData.customerData.PaymentRequest.UDF3,
            UDF4: paymentData.customerData.PaymentRequest.UDF4,
            UDF5: paymentData.customerData.PaymentRequest.UDF5,
        }
        const jsonBody = JSON.stringify(postRequest)

        let encryptedPostRequest = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        let postData = {
            payload: encryptedPostRequest.toString(),
        }

        dispatch(
            processCancelledTransaction(postData, (res) => {
                if (res.statusCode === 200) {
                    window.location.replace(
                        paymentData.customerData.PaymentRequest.RedirectUrl
                    )
                }
            })
        )
    }

    const GetSavedCardDetail = (val) => {
        const postRequest = {
            CustomerId: paymentData.customerData.PaymentRequest.CustomerCode,
            ClientId: paymentData.customerData.PaymentRequest.ClientId,
            PaymentCategory:
                paymentData.customerData.PaymentRequest.PaymentCategory,
        }
        const jsonBody = JSON.stringify(postRequest)
        let encryptedPostRequest = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )
        let postData = {
            payload: encryptedPostRequest.toString(),
        }

        const decryptedpayload = CryptoJS.AES.decrypt(postData.payload, key, {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        })
        const decryptedbody = decryptedpayload.toString(CryptoJS.enc.Utf8)

        let actualbody = JSON.parse(decryptedbody)
        // console.log('payload', actualbody)
        dispatch(
            getSavedCardDetailByClientID(postData, (res) => {
                if (res.statusCode === 200) {
                    const decryptedResponse = CryptoJS.AES.decrypt(
                        res.data,
                        key,
                        {
                            keySize: 128 / 8,
                            iv: iv,
                            mode: CryptoJS.mode.CBC,
                            padding: CryptoJS.pad.Pkcs7,
                        }
                    )
                    const decrypted = decryptedResponse.toString(
                        CryptoJS.enc.Utf8
                    )

                    let actualResponse = JSON.parse(decrypted)
                    // console.log(actualResponse)
                    dispatch({
                        type: SAVE_CARD_DATA,
                        payload: actualResponse,
                    })
                    if (val === 'axis') {
                        handlePGOptionsVisibility('axis')
                    } else if (val === 'hdfc') {
                        handlePGOptionsVisibility('hdfc')
                    }
                }
            })
        )
    }

    return (
        <div className="m-sm-30" style={{ paddingBottom: '100px' }}>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">
                    {'Entitity Timed Out'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        You are being redirected....
                    </DialogContentText>
                </DialogContent>
            </Dialog>
            <Grid pt={6} container spacing={0}>
                <Grid item xs={0} md={1}></Grid>
                <Grid item xs={12} md={10}>
                    <Card
                        className="px-6 pt-2 pb-4"
                        style={{ backgroundColor: 'white', margin: 10 }}
                    >
                        <div
                            style={{
                                backgroundColor: '#2177F9',
                                padding: '10px',
                                color: 'white',
                            }}
                        >
                            <Typography>CHECKOUT</Typography>
                        </div>
                        <Grid container spacing={0}>
                            <Grid item xs={12} md={6}>
                                {loading.isLoading ? (
                                    <>
                                        <div style={{ padding: '10px' }}>
                                            <Skeleton
                                                height={50}
                                                style={{
                                                    marginTop: '5px',
                                                    marginBottom: '5px',
                                                }}
                                                enableAnimation={true}
                                                count={4}
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <Box p={2}>
                                            <Box
                                                sx={{
                                                    p: 1,
                                                }}
                                            >
                                                <Grid container spacing={0}>
                                                    <Grid item xs={6} md={3}>
                                                        <Typography className="title">
                                                            Customer Name:
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={6} md={9}>
                                                        <Typography className="remarks">
                                                            {
                                                                paymentData
                                                                    .customerData
                                                                    .PaymentRequest
                                                                    .CustomerName
                                                            }{' '}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={0}>
                                                    <Grid item xs={6} md={3}>
                                                        <Typography className="title">
                                                            Transaction ID:
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={6} md={9}>
                                                        <Typography className="remarks">
                                                            {
                                                                paymentData
                                                                    .customerData
                                                                    .PaymentRequest
                                                                    .TrackID
                                                            }
                                                        </Typography>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={0}>
                                                    <Grid item xs={6} md={3}>
                                                        <Typography className="title">
                                                            Document Number:
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={6} md={9}>
                                                        <Typography className="remarks">
                                                            {
                                                                paymentData
                                                                    .customerData
                                                                    .PaymentRequest
                                                                    .OrderNo
                                                            }
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={0}>
                                                    <Grid item xs={6} md={3}>
                                                        <Typography className="title">
                                                            Remarks:
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={6} md={9}>
                                                        <Typography className="remarks">
                                                            {
                                                                paymentData
                                                                    .customerData
                                                                    .PaymentRequest
                                                                    .Remarks
                                                            }
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={0}>
                                                    <Grid item xs={6} md={3}>
                                                        <Typography className="title">
                                                            Payment Amount:
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={6} md={9}>
                                                        <Typography className="remarks">
                                                            INR{' '}
                                                            {DateUtilService.formatToCurrency(
                                                                paymentData
                                                                    .customerData
                                                                    .PaymentRequest
                                                                    .Amount
                                                            )}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                {charges && (
                                                    <Grid container spacing={0}>
                                                        {charges?.AppliedCharges >
                                                            0 && (
                                                            <>
                                                                <Grid
                                                                    item
                                                                    xs={6}
                                                                    md={3}
                                                                >
                                                                    <Typography
                                                                        className="title"
                                                                        color="red"
                                                                    >
                                                                        Convenience
                                                                        Fee:
                                                                    </Typography>
                                                                </Grid>

                                                                <Grid
                                                                    item
                                                                    xs={6}
                                                                    md={9}
                                                                >
                                                                    <Typography
                                                                        className="remarks"
                                                                        color="red"
                                                                    >
                                                                        INR{' '}
                                                                        {
                                                                            charges.AppliedCharges
                                                                        }
                                                                    </Typography>
                                                                </Grid>
                                                            </>
                                                        )}

                                                        {charges?.PlatformFee >
                                                            0 && (
                                                            <>
                                                                <Grid
                                                                    item
                                                                    xs={6}
                                                                    md={3}
                                                                >
                                                                    <Typography
                                                                        className="title"
                                                                        color="red"
                                                                    >
                                                                        Platform
                                                                        Fee :
                                                                    </Typography>
                                                                </Grid>

                                                                <Grid
                                                                    item
                                                                    xs={6}
                                                                    md={9}
                                                                >
                                                                    <Typography
                                                                        className="remarks"
                                                                        color="red"
                                                                    >
                                                                        INR{' '}
                                                                        {
                                                                            charges.PlatformFee
                                                                        }
                                                                    </Typography>
                                                                </Grid>
                                                            </>
                                                        )}

                                                        {charges?.GST > 0 && (
                                                            <>
                                                                <Grid
                                                                    item
                                                                    xs={6}
                                                                    md={3}
                                                                >
                                                                    <Typography
                                                                        className="title"
                                                                        color="red"
                                                                    >
                                                                        GST :
                                                                    </Typography>
                                                                </Grid>

                                                                <Grid
                                                                    item
                                                                    xs={6}
                                                                    md={9}
                                                                >
                                                                    <Typography
                                                                        className="remarks"
                                                                        color="red"
                                                                    >
                                                                        INR{' '}
                                                                        {
                                                                            charges.GST
                                                                        }
                                                                    </Typography>
                                                                </Grid>
                                                            </>
                                                        )}

                                                        {charges?.GST > 0 && (
                                                            <>
                                                                <Grid
                                                                    item
                                                                    xs={6}
                                                                    md={3}
                                                                >
                                                                    <Typography
                                                                        className="title"
                                                                        color={
                                                                            'red'
                                                                        }
                                                                    >
                                                                        Total
                                                                        Amount :
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={6}
                                                                    md={9}
                                                                >
                                                                    <Typography
                                                                        className="remarks"
                                                                        color={
                                                                            'red'
                                                                        }
                                                                    >
                                                                        {charges?.TotalAmount
                                                                            ? `INR ${charges?.TotalAmount}`
                                                                            : 'N/A'}
                                                                    </Typography>
                                                                </Grid>
                                                            </>
                                                        )}
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={12}
                                                        >
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={
                                                                            acceptCharges
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            setAcceptCharges(
                                                                                e
                                                                                    .target
                                                                                    .checked
                                                                            )
                                                                        }
                                                                    />
                                                                }
                                                                label={
                                                                    <Typography
                                                                        variant="caption" // Smaller font size (e.g., 0.75rem)
                                                                        sx={{
                                                                            fontStyle:
                                                                                'italic',
                                                                            fontSize:
                                                                                '0.75rem', // Further customize size if needed
                                                                        }}
                                                                    >
                                                                        Please
                                                                        note and
                                                                        accept
                                                                        the
                                                                        transaction
                                                                        charges
                                                                        to
                                                                        proceed
                                                                    </Typography>
                                                                }
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </Box>
                                        </Box>
                                    </>
                                )}
                            </Grid>

                            <Grid
                                sx={{ borderLeft: '2px solid silver' }}
                                item
                                xs={12}
                                md={6}
                            >
                                {loading.isLoading ? (
                                    <>
                                        <div
                                            style={{
                                                padding: '10px',
                                                marginBottom: '10px',
                                            }}
                                        >
                                            <Skeleton
                                                height={50}
                                                style={{
                                                    marginTop: '10px',
                                                    marginBottom: '10px',
                                                }}
                                                enableAnimation={true}
                                                count={1}
                                            />
                                            <Skeleton
                                                height={180}
                                                enableAnimation={true}
                                                count={1}
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {paymentGatewayOption.isPaymentOptionVisible ===
                                        true ? (
                                            <>
                                                <Box sx={{ p: 3 }}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={6}>
                                                            <Typography className="title">
                                                                Choose a Payment
                                                                Method
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <div
                                                                style={{
                                                                    display:
                                                                        'flex',
                                                                    color: '#6C905B',
                                                                    float: 'right',
                                                                }}
                                                            >
                                                                <LockIcon
                                                                    style={{
                                                                        fontSize:
                                                                            '20px',
                                                                        paddingTop:
                                                                            '8px',
                                                                    }}
                                                                />
                                                                <Typography
                                                                    sx={{
                                                                        color: '#6C905B',
                                                                    }}
                                                                    className="title"
                                                                >
                                                                    {' '}
                                                                    Secure
                                                                    Payment
                                                                </Typography>
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                    {paymentData.customerData
                                                        .PaymentOptions
                                                        .ICICIOff ||
                                                    paymentData.customerData
                                                        .PaymentOptions
                                                        .ICICIOff ===
                                                        false ? null : (
                                                        <>
                                                            <Accordion>
                                                                <AccordionSummary
                                                                    expandIcon={
                                                                        <ExpandMoreIcon />
                                                                    }
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            image1
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        ICICI
                                                                    </Typography>
                                                                </AccordionSummary>
                                                                {paymentData
                                                                    .customerData
                                                                    .PaymentOptions
                                                                    .ICICIOn ||
                                                                paymentData
                                                                    .customerData
                                                                    .PaymentOptions
                                                                    .ICICIOff ===
                                                                    false ? null : (
                                                                    <>
                                                                        <AccordionDetails
                                                                            style={{
                                                                                paddingLeft: 55,
                                                                                backgroundColor:
                                                                                    'silver',
                                                                            }}
                                                                        >
                                                                            <Typography>
                                                                                ICICI
                                                                            </Typography>
                                                                            <br />
                                                                            <Typography>
                                                                                ICICI
                                                                            </Typography>
                                                                        </AccordionDetails>
                                                                    </>
                                                                )}
                                                            </Accordion>
                                                        </>
                                                    )}

                                                    {paymentData.customerData
                                                        .PaymentOptions
                                                        .HDFCOff ||
                                                    paymentData.customerData
                                                        .PaymentOptions
                                                        .HDFCSeamless ===
                                                        false ? null : (
                                                        <>
                                                            <Accordion
                                                                onClick={() =>
                                                                    GetSavedCardDetail(
                                                                        'hdfc'
                                                                    )
                                                                }
                                                            >
                                                                <AccordionSummary
                                                                    expandIcon={
                                                                        paymentData
                                                                            .customerData
                                                                            .PaymentOptions
                                                                            .HDFCOff &&
                                                                        paymentData
                                                                            .customerData
                                                                            .PaymentOptions
                                                                            .HDFCSeamless ===
                                                                            true ? (
                                                                            <ExpandMoreIcon />
                                                                        ) : null
                                                                    }
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            image2
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        HDFC
                                                                    </Typography>
                                                                </AccordionSummary>
                                                                {paymentData
                                                                    .customerData
                                                                    .PaymentOptions
                                                                    .HDFCSeamless &&
                                                                paymentData
                                                                    .customerData
                                                                    .PaymentOptions
                                                                    .HDFCOff ===
                                                                    true ? (
                                                                    <>
                                                                        <AccordionDetails
                                                                            style={{
                                                                                paddingLeft: 55,
                                                                                backgroundColor:
                                                                                    'lightGray',
                                                                                cursor: 'pointer',
                                                                            }}
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    color: 'white',
                                                                                }}
                                                                                onClick={() =>
                                                                                    handlePGOptionsVisibility(
                                                                                        'hdfc'
                                                                                    )
                                                                                }
                                                                            >
                                                                                HDFC
                                                                                Card
                                                                            </div>
                                                                        </AccordionDetails>
                                                                        <AccordionDetails
                                                                            style={{
                                                                                paddingLeft: 55,
                                                                                backgroundColor:
                                                                                    'silver',
                                                                            }}
                                                                        >
                                                                            <Typography>
                                                                                Non-HDFC
                                                                                Card
                                                                            </Typography>
                                                                        </AccordionDetails>
                                                                    </>
                                                                ) : null}
                                                            </Accordion>
                                                        </>
                                                    )}

                                                    {paymentData.customerData
                                                        .PaymentOptions.NetB ===
                                                    true ? (
                                                        <>
                                                            <Accordion
                                                                onClick={() =>
                                                                    handlePGOptionsVisibility(
                                                                        'netBanking'
                                                                    )
                                                                }
                                                            >
                                                                <AccordionSummary
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            image3
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        Non HDFC
                                                                        Net
                                                                        Banking
                                                                    </Typography>
                                                                </AccordionSummary>
                                                            </Accordion>
                                                        </>
                                                    ) : null}
                                                    {paymentData.customerData
                                                        .PaymentOptions
                                                        .HDFCNetBanking ===
                                                    true ? (
                                                        <>
                                                            <Accordion
                                                                onClick={
                                                                    SubmitRequestHDFCNetBanking
                                                                }
                                                            >
                                                                <AccordionSummary
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            image2
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        HDFC Net
                                                                        Banking
                                                                    </Typography>
                                                                </AccordionSummary>
                                                            </Accordion>
                                                        </>
                                                    ) : null}
                                                    {paymentData.customerData
                                                        .PaymentOptions.UPI ===
                                                    true ? (
                                                        <>
                                                            <Accordion
                                                                onClick={() =>
                                                                    handlePGOptionsVisibility(
                                                                        'upi'
                                                                    )
                                                                }
                                                            >
                                                                <AccordionSummary
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            image4
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        UPI
                                                                    </Typography>
                                                                </AccordionSummary>
                                                            </Accordion>
                                                        </>
                                                    ) : null}
                                                    {paymentData.customerData
                                                        .PaymentOptions
                                                        .JioPay === true ? (
                                                        <>
                                                            <Accordion
                                                                onClick={() =>
                                                                    handlePGOptionsVisibility(
                                                                        'jioPayCard'
                                                                    )
                                                                }
                                                            >
                                                                <AccordionSummary
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            pinelabPNG
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        Credit
                                                                        Card
                                                                    </Typography>
                                                                </AccordionSummary>
                                                            </Accordion>
                                                        </>
                                                    ) : null}
                                                    {paymentData.customerData
                                                        .PaymentOptions
                                                        .JioPay === true ? (
                                                        <>
                                                            <Accordion
                                                                onClick={() =>
                                                                    handlePGOptionsVisibility(
                                                                        'jioPayNetBanking'
                                                                    )
                                                                }
                                                            >
                                                                <AccordionSummary
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            image3
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        Net
                                                                        Banking
                                                                    </Typography>
                                                                </AccordionSummary>
                                                            </Accordion>
                                                        </>
                                                    ) : null}
                                                    {paymentData.customerData
                                                        .PaymentOptions
                                                        .JioPay === true ? (
                                                        <>
                                                            <Accordion
                                                                onClick={() =>
                                                                    handlePGOptionsVisibility(
                                                                        'jioPayUpi'
                                                                    )
                                                                }
                                                            >
                                                                <AccordionSummary
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            image4
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        UPI
                                                                    </Typography>
                                                                </AccordionSummary>
                                                            </Accordion>
                                                        </>
                                                    ) : null}
                                                    {paymentData.customerData
                                                        .PaymentOptions
                                                        .JioPay === true ? (
                                                        <>
                                                            <Accordion
                                                                onClick={() =>
                                                                    handlePGOptionsVisibility(
                                                                        'jioPayDebitCard'
                                                                    )
                                                                }
                                                            >
                                                                <AccordionSummary
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            pinelabPNG
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        Debit
                                                                        Card
                                                                    </Typography>
                                                                </AccordionSummary>
                                                            </Accordion>
                                                        </>
                                                    ) : null}
                                                    {paymentData.customerData
                                                        .PaymentOptions.VTAP ===
                                                    false ? null : (
                                                        <>
                                                            <Accordion
                                                                onClick={() =>
                                                                    handlePGOptionsVisibility(
                                                                        'vtap'
                                                                    )
                                                                }
                                                            >
                                                                <AccordionSummary
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            image5
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        VTAP
                                                                    </Typography>
                                                                </AccordionSummary>
                                                            </Accordion>
                                                        </>
                                                    )}
                                                    {paymentData.customerData
                                                        .PaymentOptions
                                                        .PineLab === true ? (
                                                        <>
                                                            <Accordion
                                                                expanded={
                                                                    expanded
                                                                }
                                                                onClick={() =>
                                                                    setExpanded(
                                                                        false
                                                                    )
                                                                }
                                                            >
                                                                <AccordionSummary
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                    onClick={
                                                                        SubmitPineLabRequest
                                                                    }
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            pinelabPNG
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        Credit
                                                                        Card
                                                                    </Typography>
                                                                </AccordionSummary>
                                                            </Accordion>
                                                        </>
                                                    ) : null}
                                                    {paymentData.customerData
                                                        .PaymentOptions.Axis ===
                                                    true ? (
                                                        <>
                                                            <Accordion
                                                                onClick={() =>
                                                                    GetSavedCardDetail(
                                                                        'axis'
                                                                    )
                                                                }
                                                            >
                                                                <AccordionSummary
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            image6
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        Axis
                                                                        Card
                                                                    </Typography>
                                                                </AccordionSummary>
                                                            </Accordion>
                                                        </>
                                                    ) : null}
                                                    {paymentData.customerData
                                                        .PaymentOptions
                                                        .Kotak === true ? (
                                                        <>
                                                            <Accordion
                                                                onClick={() =>
                                                                    handlePGOptionsVisibility(
                                                                        'kotak'
                                                                    )
                                                                }
                                                            >
                                                                <AccordionSummary
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            image7
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        Kotak
                                                                    </Typography>
                                                                </AccordionSummary>
                                                            </Accordion>
                                                        </>
                                                    ) : null}
                                                    {paymentData.customerData
                                                        .PaymentOptions
                                                        .HDFCSmart === true ? (
                                                        <>
                                                            <Accordion
                                                                expanded={
                                                                    expanded
                                                                }
                                                                onClick={() =>
                                                                    setExpanded(
                                                                        false
                                                                    )
                                                                }
                                                            >
                                                                <AccordionSummary
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                    onClick={
                                                                        SubmitHDFCSmartRequest
                                                                    }
                                                                >
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={
                                                                            image2
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        className="remarks"
                                                                        p={1}
                                                                    >
                                                                        Pay
                                                                        through
                                                                        HDFC
                                                                        Smart
                                                                        Gateway
                                                                    </Typography>
                                                                </AccordionSummary>
                                                            </Accordion>
                                                        </>
                                                    ) : null}
                                                </Box>
                                            </>
                                        ) : null}

                                        {paymentGatewayOption.isHDFCVisible ===
                                        true ? (
                                            <>
                                                <HdfcPage
                                                    onBackBtnClick={
                                                        handleBackBtn
                                                    }
                                                />
                                            </>
                                        ) : null}
                                        {paymentGatewayOption.isJioPayCardVisible ===
                                        true ? (
                                            <>
                                                <JioPayCard
                                                    charges={charges}
                                                    acceptCharges={
                                                        acceptCharges
                                                    }
                                                    setCharges={setCharges}
                                                    onBackBtnClick={
                                                        handleBackBtn
                                                    }
                                                />
                                            </>
                                        ) : null}
                                        {paymentGatewayOption.isJioPayNetBankingVisible ===
                                        true ? (
                                            <>
                                                <JioPayNetBanking
                                                    charges={charges}
                                                    acceptCharges={
                                                        acceptCharges
                                                    }
                                                    setCharges={setCharges}
                                                    onBackBtnClick={
                                                        handleBackBtn
                                                    }
                                                />
                                            </>
                                        ) : null}
                                        {paymentGatewayOption.isJioPayDebitCardVisible ===
                                        true ? (
                                            <>
                                                <JioPayDebitCard
                                                    charges={charges}
                                                    acceptCharges={
                                                        acceptCharges
                                                    }
                                                    setCharges={setCharges}
                                                    onBackBtnClick={
                                                        handleBackBtn
                                                    }
                                                />
                                            </>
                                        ) : null}

                                        {paymentGatewayOption.isVTAPVisible ===
                                        true ? (
                                            <>
                                                <VTap
                                                    onBackBtnClick={
                                                        handleBackBtn
                                                    }
                                                    creditLimit={creditLimit}
                                                    showVtapOTP={
                                                        paymentGatewayOption.showVtapOTP
                                                    }
                                                    handleSubmitBtn={
                                                        submitVtapPayment
                                                    }
                                                />
                                            </>
                                        ) : null}

                                        {paymentGatewayOption.isNetBankingVisible ===
                                        true ? (
                                            <>
                                                <NetBanking
                                                    bankName={bankName}
                                                    handleBankList={
                                                        handleBankList
                                                    }
                                                    state={paymentRequest}
                                                    onSubmit={SubmitRequest}
                                                    onBackBtnClick={
                                                        handleBackBtn
                                                    }
                                                />
                                            </>
                                        ) : null}

                                        {paymentGatewayOption.isUPIVisible ===
                                        true ? (
                                            <>
                                                <UPI
                                                    onBackBtnClick={
                                                        handleBackBtn
                                                    }
                                                />
                                            </>
                                        ) : null}
                                        {paymentGatewayOption.isJioPayUPIVisible ===
                                        true ? (
                                            <>
                                                <JioPayUPI
                                                    charges={charges}
                                                    acceptCharges={
                                                        acceptCharges
                                                    }
                                                    setCharges={setCharges}
                                                    onBackBtnClick={
                                                        handleBackBtn
                                                    }
                                                />
                                            </>
                                        ) : null}
                                        {/* {paymentGatewayOption.isPineLabVisible ===
                                        true ? (
                                            <>
                                                <div
                                                    onSubmit={
                                                        SubmitPineLabRequest
                                                    }
                                                    onBackBtnClick={
                                                        handleBackBtn
                                                    }
                                                />
                                            </>
                                        ) : null} */}
                                        {paymentGatewayOption.isAxisVisible ===
                                        true ? (
                                            <>
                                                <AxisPage
                                                    onBackBtnClick={
                                                        handleBackBtn
                                                    }
                                                />
                                            </>
                                        ) : null}
                                        {paymentGatewayOption.isKotakVisible ===
                                        true ? (
                                            <>
                                                <KotakPage
                                                    onBackBtnClick={
                                                        handleBackBtn
                                                    }
                                                />
                                            </>
                                        ) : null}
                                    </>
                                )}
                                {paymentGatewayOption.isPaymentOptionVisible ===
                                true ? (
                                    <button
                                        id="iframeButton"
                                        type="button"
                                        className="cancelPaytmentButton"
                                        onClick={CancelTransaction}
                                    >
                                        Cancel
                                    </button>
                                ) : (
                                    ''
                                )}
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
                <Grid item xs={0} md={1}></Grid>
            </Grid>
        </div>
    )
}

export default Checkout
